export default __webpack_public_path__ + "static/media/KHL.a5894b7e.svg";